if (!customElements.get('bundle-card')) {
  customElements.define(
    'bundle-card',
    class BundleCard extends HTMLElement {
      connectedCallback() {
        this.variantContainer = this.querySelector('[data-variants-selectors]');
        this.idInput = this.querySelector('input[name="id"]');
        try {
          this.variants = JSON.parse(this.dataset.variantsJson || '[]');
        } catch (e) {
          this.variants = [];
        }

        if (this.variantContainer) {
          this.variantContainer.querySelectorAll('select').forEach((select) => {
            select.addEventListener('change', () => this.onVariantChange());
          });
        }
      }

      get optionElements() {
        return this.variantContainer
          ? Array.from(
              this.variantContainer.querySelectorAll('select, input[type="hidden"][data-option-index]')
            )
          : [];
      }

      onVariantChange() {
        if (!this.variantContainer) return;

        this.refreshAvailableOptions();

        const selected = [];
        this.optionElements.forEach((el) => {
          selected[parseInt(el.dataset.optionIndex, 10)] = el.value;
        });

        let matchedVariant = this.variants.find((v) =>
          v.options.every((opt, i) => opt === selected[i])
        );

        // Fallback: if the color-leads filter produced a combination with no exact
        // variant (products with 3+ options, or two multi-value options where none
        // is a color), keep a real purchasable variant selected instead of silently
        // dropping this card from "add all to cart".
        if (!matchedVariant) {
          const colorSelect = this.variantContainer.querySelector('select[data-option-color]');
          if (colorSelect) {
            matchedVariant = this.variants.find(
              (v) => v.options[parseInt(colorSelect.dataset.optionIndex, 10)] === colorSelect.value
            );
          }
          if (!matchedVariant) matchedVariant = this.variants[0];
          if (matchedVariant) {
            this.optionElements.forEach((el) => {
              const i = parseInt(el.dataset.optionIndex, 10);
              if (matchedVariant.options[i] != null) el.value = matchedVariant.options[i];
            });
          }
        }

        if (!matchedVariant) {
          if (this.idInput) {
            this.idInput.value = '';
            this.idInput.setAttribute('disabled', 'disabled');
          }
          return;
        }

        if (this.idInput) {
          this.idInput.value = matchedVariant.id;
          this.idInput.removeAttribute('disabled');
        }
        this.updatePrice(matchedVariant);
        this.updateBadge(matchedVariant);
        this.updateImage(matchedVariant);
      }

      // Color leads: every non-color select only shows values available for the
      // chosen color; if the current value became invalid, fall back to the first
      // still-available value so the bundle can always be added to cart.
      refreshAvailableOptions() {
        const colorSelect = this.variantContainer.querySelector('select[data-option-color]');
        if (!colorSelect) return;

        const colorIdx = parseInt(colorSelect.dataset.optionIndex, 10);
        const colorValue = colorSelect.value;

        this.variantContainer.querySelectorAll('select[data-option-index]').forEach((select) => {
          if (select === colorSelect) return;

          const idx = parseInt(select.dataset.optionIndex, 10);
          let selectedStillValid = false;
          let firstAvailable = '';

          select.querySelectorAll('option').forEach((option) => {
            const available = this.variants.some((variant) => {
              if (variant.options[idx] !== option.value) return false;
              if (colorValue && variant.options[colorIdx] !== colorValue) return false;
              return true;
            });
            option.hidden = !available;
            option.disabled = !available;
            if (available) {
              if (firstAvailable === '') firstAvailable = option.value;
              if (option.value === select.value) selectedStillValid = true;
            }
          });

          if (!selectedStillValid) {
            select.value = firstAvailable;
          }
        });
      }

      updatePrice(variant) {
        const priceEl = this.querySelector('[data-bundle-price] .f-price');
        if (!priceEl) return;
        const money = (c) => FoxTheme.Currency.formatMoney(c, FoxTheme.settings.moneyFormat);

        priceEl.classList.remove('f-price--sold-out', 'f-price--on-sale');
        if (!variant.available) {
          priceEl.classList.add('f-price--sold-out');
        } else if (variant.compare_at_price > variant.price) {
          priceEl.classList.add('f-price--on-sale');
        }

        const regular = priceEl.querySelector('.f-price__regular .f-price-item--regular');
        if (regular) regular.innerHTML = money(variant.price);

        const sale = priceEl.querySelector('.f-price__sale');
        if (sale) {
          const saleItem = sale.querySelector('.f-price-item--sale');
          const compareItem = sale.querySelector('.f-price-item--regular');
          if (saleItem) saleItem.innerHTML = money(variant.price);
          if (compareItem) compareItem.innerHTML = '<s>' + money(variant.compare_at_price) + '</s>';
        }
      }

      updateBadge(variant) {
        const badge = this.querySelector('[data-bundle-badge]');
        if (!badge) return;
        if (variant.compare_at_price > variant.price) {
          const pct = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          badge.textContent = pct + '%';
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }

      updateImage(variant) {
        if (!variant.featured_image || !variant.featured_image.src) return;
        const img = this.querySelector('[data-bundle-image] img');
        if (!img) return;
        try {
          const url = new URL(variant.featured_image.src, window.location.origin);
          url.searchParams.set('width', '600');
          img.src = url.toString();
        } catch (e) {
          img.src = variant.featured_image.src;
        }
        img.srcset = '';
      }
    }
  );
}
